module.exports = __webpack_public_path__ + "img/hd32.54a6b0ed.png";